/**
 * Singleton row of org-level feature toggles. Unlike `organization` (server
 * authoritative, written via a backend PUT), this is freely client-writable and syncs
 * like any other table — see backend/schemas/customer.sql's org_settings table.
 */
export type GeocodingProvider = 'radar' | 'here';

export interface OrgSettings {
  id: string;
  leaderboard_enabled: number;
  /** Comma-separated ISO 3166-1 alpha-2 codes (e.g. 'US,CA') restricting map address-search
   *  results; empty string means unrestricted. */
  search_country_codes: string;
  /** Which service backs BOTH map address search and pin-drop reverse geocoding. */
  geocoding_provider: GeocodingProvider;
  updated_by: string;
  updated_at: number;
}

export const ORG_SETTINGS_ID = 'org-settings';
